import { CreateBeneficiaryType } from 'contexts/bankAccount/bankAccountType';
import moment from 'moment';
import { ResolveTransferDateType, ResourceTransferDateEnum } from 'services/accounts/bankAccount';
import { isValidString } from './StringFormats';
import { useForm } from 'react-hook-form';

export function dateDiff(
    startingDate: string | number | Date | undefined,
    endingDate: string | number | Date | undefined
) {
    if (!startingDate) {
        return 'N/D';
    }

    var startDate = new Date(new Date(startingDate).toISOString().substring(0, 10));

    if (!endingDate) {
        endingDate = new Date().toISOString().substring(0, 10);
    }
    var endDate = new Date(endingDate);
    if (startDate > endDate) {
        var swap = startDate;
        startDate = endDate;
        endDate = swap;
    }
    var startYear = startDate?.getFullYear();
    var february =
        (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0 ? 29 : 28;
    var daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    var yearDiff = endDate?.getFullYear() - startYear;
    var monthDiff = endDate?.getMonth() - startDate?.getMonth();
    if (monthDiff < 0) {
        yearDiff--;
        monthDiff += 12;
    }
    var dayDiff = endDate?.getDate() - startDate?.getDate();
    if (dayDiff < 0) {
        if (monthDiff > 0) {
            monthDiff--;
        } else {
            yearDiff--;
            monthDiff = 11;
        }
        dayDiff += daysInMonth[startDate?.getMonth()];
    }

    let yearLabel = 'anos';
    if (yearDiff === 1) {
        yearLabel = 'ano';
    }

    let monthLabel = 'meses';
    if (monthDiff === 1) {
        monthLabel = 'mês';
    }

    let dayLabel = 'dias';
    if (dayDiff === 1) {
        dayLabel = 'dia';
    }

    if (yearDiff > 0 && monthDiff > 0) {
        return `${yearDiff} ${yearLabel} e ${monthDiff} ${monthLabel}`;
    } else if (yearDiff > 0) {
        return `${yearDiff} ${yearLabel}`;
    } else if (monthDiff > 0) {
        return `${monthDiff} ${monthLabel}`;
    } else {
        return `${dayDiff} ${dayLabel}`;
    }
}

export const formatDeadLine = (deadLine: string) => {
    const hour = '23:59:59';
    const data = new Date(deadLine);
    const [hours, minutes, seconds] = hour.split(':');
    //@ts-ignore
    data.setUTCHours(hours, minutes, seconds);
    return data.toISOString();
};

const hoursStart = { hour: 0, minute: 0, second: 0, millisecond: 0 };

export const dateFormatedNonHours = (dateIso: string) => {
    const lastLetter = dateIso.indexOf('T');
    return dateIso.slice(0, lastLetter);
};

export const calculatePeriodRangeTwoDate = (
    startDate: string,
    endDate: string
): {
    days: number;
    month: number;
} => {
    const dateubtract: number = new Date(endDate).getTime() - new Date(startDate).getTime();
    const days = (dateubtract / (1000 * 60 * 60 * 24)) as number;
    const month = days / 30;
    return {
        days,
        month: String(month).startsWith('0') ? 1 : Number.parseInt(month.toString())
    };
};

export const applyFilterByPeriod = (index: number) => {
    let initialDate: Date = new Date();
    let finalDate: Date = moment().add(30, 'days').toDate();

    const setDates = (startDate: Date) => {
        initialDate = startDate;
        finalDate = new Date();
    };

    const option: { [index: number]: () => void } = {
        0: () => setDates(moment().set(hoursStart).toDate()),
        1: () => setDates(moment().subtract(1, 'days').toDate()),
        2: () => setDates(moment().subtract(1, 'weeks').toDate()),
        3: () => setDates(moment().subtract(1, 'months').toDate()),
        4: () => setDates(moment().subtract(3, 'months').toDate()),
        5: () => setDates(moment().subtract(6, 'months').toDate())
    };

    if (option[index]) {
        option[index]();
    }

    const initialDateFormated = dateFormatedNonHours(initialDate.toISOString());
    const finalDateFormated = dateFormatedNonHours(finalDate.toISOString());

    return {
        initialDate: initialDateFormated,
        finalDate: finalDateFormated
    };
};

export const currentDateWithSetHours = new Date().setHours(0, 0, 0, 0);
export function toIsoStringWithTimezone(date: Date) {
    const pad = (num: number) => String(num).padStart(2, '0');

    // Ajustando manualmente a data para o fuso horário de São Paulo (UTC-3)
    const year = date?.getFullYear();
    const month = pad(date?.getMonth() + 1);
    const day = pad(date?.getDate());
    const hours = pad(date?.getHours());
    const minutes = pad(date?.getMinutes());
    const seconds = pad(date?.getSeconds());
    const milliseconds = String(date?.getMilliseconds()).padStart(3, '0');

    // Construindo a string no formato ISO com o fuso horário de São Paulo
    const dateFormated = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}-03:00`;
    return dateFormated;
}

export function getRelativeDate(date: string): string {
    const now = moment();
    const inputDate = moment(date);

    if (inputDate.isSame(now, 'day')) {
        return 'Hoje';
    } else if (inputDate.isSame(moment().subtract(1, 'days'), 'day')) {
        return 'Ontem';
    } else if (inputDate.isSame(now, 'week')) {
        return 'Essa Semana';
    } else if (inputDate.isSame(now, 'month')) {
        return 'Este Mês';
    } else if (inputDate.isSame(moment().subtract(1, 'months'), 'month')) {
        return 'Mês Passado';
    } else {
        return inputDate.format('MMMM YYYY');
    }
}

export function formatCustomDate(date: string) {
    const inputDate = moment(date);

    const day = inputDate.format('DD');
    const month = inputDate.format('MM');
    const year = inputDate.format('YYYY');
    const time = inputDate.format('HH:mm');

    if (Number(year) === new Date().getFullYear()) {
        return `${day}/${month} às ${time}`;
    }

    return `${day}/${month}/${year} às ${time}`;
}

export function formatDate(date: string) {
    return moment(date).format('DD/MM/YYYY');
}

export function convertToDateWithMoment(dateString: string): string | null {
    if (dateString.length !== 8) {
        return null;
    }

    const date = moment(dateString, 'DDMMYYYY', true);

    if (!date.isValid()) {
        return null;
    }

    return date
        .utcOffset('-03:00')
        .set({ minute: 0, second: 0, millisecond: 0 })
        .format('YYYY-MM-DDTHH:mm:ssZ');
}

function subtractDaysFromDate(day: number): Date {
    const date = new Date();
    const replaceWithDay = date.setDate(date.getDate() - day);
    return new Date(replaceWithDay);
}

export const skipDaysFromDate = (day: number) => {
    return {
        initialDate: formatInitialDate(subtractDaysFromDate(day)),
        finalDate: formatFinalDate(new Date())
    };
};

export const formatInitialDate = (date: Date): string => {
    return moment(date)
        .utcOffset('-03:00')
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .format('YYYY-MM-DDTHH:mm:ssZ');
};

export const formatFinalDate = (date: Date): string => {
    return moment(date)
        .set({ hour: 23, minute: 59, second: 59, millisecond: 999 })
        .utcOffset('-03:00', true)
        .format('YYYY-MM-DDTHH:mm:ss.SSSZZ')
        .replace('.999', '.999999')
        .replace(/(-\d{2})(\d{2})$/, '$1:$2');
};

export function resolveTransferDate(props: ResolveTransferDateType): string {
    const { isRootTenancy, resource, typeSelected, transferDateInput } = props;

    if (typeSelected === 'today') {
        return new Date().toISOString();
    }

    const date = new Date(transferDateInput ?? '');

    if (resource === ResourceTransferDateEnum.Pix) {
        date.setHours(6, 0, 0, 0);
        return toIsoStringWithTimezone(date);
    }

    if (isRootTenancy) {
        date.setHours(6, 0, 0, 0);
    } else {
        date.setHours(9, 5, 0, 0);
    }

    return toIsoStringWithTimezone(date);
}

export function setTransferDateBasedOnTimeAndBankcode(
    formValues: CreateBeneficiaryType,
    setValue: ReturnType<typeof useForm>['setValue']
) {
    const currentHour = moment().hour();
    const isAfterFivePM = currentHour >= 17;

    const bankCode = String(formValues?.bank);
    const shouldScheduleForTomorrow =
        isAfterFivePM && isValidString(bankCode) && bankCode !== '457';

    const transferDate = shouldScheduleForTomorrow
        ? moment().add(1, 'day').format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD');

    setValue('transferDate', transferDate);
    setValue('transferDateSelected', shouldScheduleForTomorrow ? 'otherDay' : 'today');
}
export function formatDateFromNumberString(dateNumber: string): string {
    if (!/^\d{8}$/.test(dateNumber)) return dateNumber;
    const day = dateNumber.slice(0, 2);
    const month = dateNumber.slice(2, 4);
    const year = dateNumber.slice(4, 8);
    return `${day}/${month}/${year}`;
}
